export default {
  common: {
    period: 'Período',
    date: 'Data',
    value: 'Valor',
    status: 'Status',
    cancel: 'Cancelar',
    save: 'Salvar',
    process: 'Processar',
    noData: 'Não há dados disponíveis',
    filterDisabled: 'Filtro de Data Desativado',
    ok: 'OK',
    search: 'Buscar',
    of: 'de',
    id: 'ID',
    name: 'Nome',
    required: 'Campo obrigatório',
    apply: 'Aplicar',
    total: 'Total',
    dateModal: {
      selecioneData: 'Selecione uma data',
    },
  },
  auth: {
    loginTitle: 'Faça seu login',
    email: 'E-mail',
    password: 'Senha',
    forgotPassword: 'Esqueci minha senha',
    enterBtn: 'Entrar',
    noAccount: 'Ainda não tem conta?',
    registerLink: 'Cadastre-se',
    nameRequired: 'Nome é obrigatório.',
    passwordRequired: 'Senha é obrigatório.',
    changePassword: 'Alterar senha',
    newPassword: 'Nova senha',
    confirmPassword: 'Confirmar senha',
    passwordsDontMatch: 'Senhas não conferem.',
    senhaAlterada: 'Senha alterada com sucesso',
  },
  cadastro: {
    title: 'Cadastre-se',
    subtitle: 'Por favor, preencha o formulário abaixo para criar sua conta de afiliado.',
    nome: 'Nome',
    whatsapp: 'WhatsApp',
    confirmeSenha: 'Confirme a senha',
    euAceito: 'Eu li e aceito os',
    termosCondicoes: 'Termos e Condições',
    cadastrarBtn: 'Cadastre-se',
    jaTemConta: 'Já tem uma conta?',
    termosTitulo: 'Contrato de Adesão ao Programa de Afiliados – {brand}',
    concordoTermos: 'Li e Concordo com os Termos',
    emailRequired: 'E-mail é obrigatório.',
    emailInvalido: 'E-mail inválido.',
    nomeMinCaracteres: 'Nome deve ter no mínimo 3 caracteres.',
    whatsappRequired: 'WhatsApp é obrigatório.',
    whatsappMinCaracteres: 'WhatsApp deve ter 15 caracteres.',
    senhaRequired: 'Senha é obrigatória.',
    senhaMinCaracteres: 'A senha deve ter no mínimo 6 caracteres.',
    confirmacaoRequired: 'Confirmação de senha é obrigatória.',
    senhasNaoCoincidem: 'As senhas não coincidem.',
    termosRequired: 'Você deve aceitar os Termos e Condições para continuar.',
  },
  painel: {
    title: 'Dashboard',
    subtitle: 'Acompanhe suas métricas e resultados',
    visitas: 'Visitas',
    qftdsCpa: 'QFTDs, CPA',
    subAfiliados: 'Comissão de Sub Afiliados',
    revShare: 'RevShare',
    kpi: {
      comissoes: 'Comissões',
      registros: 'Registros',
      ftds: 'FTDs',
      cpa: 'CPA',
      revshare: 'Revshare',
      novo: 'Novo',
    },
    ajustes: {
      title: 'Ajustes',
      data: 'Data',
      valor: 'Ajustes',
      empty: 'Nenhum ajuste no período selecionado',
    },
  },
  carteira: {
    title: 'Carteira',
    saldoAtual: 'Saldo atual',
    ultimaAtualizacaoSaldo: 'Última atualização do saldo',
    solicitarSaque: 'Solicitar saque',
    minWithdraw: 'Valor mínimo para saque é:',
    historicoSaques: 'Histórico de Saques',
    metodoPagamento: 'Método de pagamento',
    chavePix: 'Chave PIX',
    valorSaque: 'Valor do saque',
    notaFiscal: 'Nota Fiscal',
    notaFiscalSub: 'Anexe o PDF da nota fiscal referente ao valor do saque',
    selecionarPdf: 'Selecionar PDF',
    cliqueSelecionar: 'Clique para selecionar o arquivo',
    ouArraste: 'ou arraste e solte aqui',
    cnpj: 'CNPJ',
    cnpjSub: 'Informe seu CNPJ para prosseguir com o saque',
    comissoesSubAfiliados: 'Comissões de sub-afiliados',
    quantidadeFtd: 'Quantidade FTD',
    comissoesAcumuladas: 'Comissões acumuladas',
    pagamentosRecebidos: 'Pagamentos já recebidos',
    cnpjDigits: 'CNPJ deve ter 14 dígitos',
    cnpjFormat: 'CNPJ deve ter o formato 00.000.000/0000-00',
    cnpjCompleto: 'Por favor, digite o CNPJ completo (14 dígitos)!',
    soPdf: 'Por favor, selecione apenas arquivos PDF!',
    maxArquivo: 'O arquivo deve ter no máximo 10MB!',
    notaFiscalAnexada: 'Nota fiscal anexada com sucesso!',
    anexeNotaFiscal: 'Por favor, anexe a nota fiscal antes de solicitar o saque!',
    valorMaiorSaldo: 'Valor do saque maior que saldo atual!',
    saqueSucesso: 'Saque solicitado com sucesso!',
    erroSaque: 'Erro ao solicitar saque',
    status: {
      pago: 'Pago',
      cancelado: 'Cancelado',
      expirado: 'Expirado',
      pendente: 'Pendente',
    },
    pix: {
      celular: 'Celular',
      aleatorio: 'Aleatório',
      chaveCpf: 'Chave CPF',
      chaveCnpj: 'Chave CNPJ',
      chaveAleatoria: 'Chave Aleatória',
    },
  },
  links: {
    title: 'Links de Destino',
    personalizar: 'Personalizar',
    editarLink: 'Editar Link',
    dadosDoLink: 'Dados do Link',
    nome: 'Nome',
    tipo: 'Tipo',
    dominio: 'Domínio',
    tag: 'TAG',
    link: 'Link',
    utmSource: 'UTM Source',
    utmMedium: 'UTM Medium',
    utmCampaign: 'UTM Campaign',
    utmTerm: 'UTM Term',
    utmContent: 'UTM Content',
    copiarLink: 'Copiar Link',
    gerarLink: 'Gerar Link',
    gerando: 'Gerando...',
    gerado: 'Gerado!',
    linkCopiado: 'Link Copiado!',
    linkSalvo: 'Link salvo!',
    linkCriado: 'Link criado com sucesso!',
    criarLinkDestino: 'Criar Link de Destino',
    nomeDoLink: 'Nome do link',
    urlDestino: 'URL de destino',
    salveParaGerar: 'Salve para gerar o link',
    erroGerarLink: 'Erro ao gerar link',
    erroCopiar: 'Não foi possível copiar o link',
    escaneieQrCode: 'Escaneie aqui seu Link!',
    somenteAfiliados: 'Apenas afiliados podem criar links!',
    semDados: 'Não há dados disponíveis',
    headers: {
      paginaDestino: 'Página de destino',
      tag: 'Tag',
      link: 'Link',
      linkReduzido: 'Link Reduzido',
      acoes: 'Ações do link',
      nomeDoLink: 'Nome do link',
      marcaId: 'Marca / #ID',
    },
  },
  pixel: {
    title: 'Pixel',
    facebookPixelId: 'Facebook Pixel ID',
    idsSalvos: 'Ids cadastrado com sucesso!',
  },
  clientes: {
    title: 'Cadastros',
    headers: {
      id: 'ID',
      nome: 'Nome',
    },
  },
  relatorios: {
    title: 'Relatório',
    rangeDatas: 'Range de data não pode passar de 31 dias',
    filtrosAtivos: 'Filtros ativos',
    aggregateByLabel: 'Agrupar por período',
    groupByLabel: 'Agrupar por',
    groupByPlaceholder: 'Agrupar por',
    aggregateBy: {
      day: 'Dia',
      week: 'Semana',
      month: 'Mês',
    },
    groupBy: {
      none: 'Sem agrupamento',
    },
    columns: {
      period: 'Período',
      visits: 'Visitas',
      registrations: 'Registros',
      qftds: 'QFTDs',
      ftds: 'FTDs',
      cpa: 'CPA',
      revshare: 'Revshare',
      commissions: 'Comissões',
      subAffCom: 'Com. Sub Afiliados',
      withdrawals: 'Retiradas',
      netDeposit: 'Depósito Líquido',
      depositAmount: 'Valor Depositado',
      ftdsAmount: 'Valor FTDs',
      netPnl: 'NET/PL',
      adjustments: 'Ajustes',
      payments: 'Pagamentos',
      balance: 'Saldo',
    },
    columnsSettings: {
      title: 'Colunas visíveis',
    },
    aniversariantes: {
      title: 'Aniversariantes',
      aniversariantesDoMes: 'Aniversariantes do Mês',
      visualizar: 'Visualizar',
      relatorioDeAniversariantes: 'Relatório de Aniversariantes',
    },
    comissoesPromotores: {
      selecioneOMes: 'Selecione o mês',
    },
    descarga: {
      title: 'Descarga',
    },
    gecom: {
      modalHistoricoVendas: {
        title: 'Histórico de Vendas',
      },
    },
    gecomMobile: {
      pdv: 'PDV',
    },
    lancamentoCaixa: {
      title: 'Lançamento de Caixa',
      selecioneUmaData: 'Selecione uma data',
      visualizar: 'Visualizar',
      relatorioLancamentoDeCaixa: 'Relatório Lançamento de caixa',
    },
    parceiros: {
      selecioneOMes: 'Selecione o mês',
    },
    premioPagoCentral: {
      pdv: 'PDV',
      valorDoPremio: 'Valor do premio',
      nrJogoToken: 'Nº Jogo / token',
    },
    resultadosBingo: {
      dataInicial: 'Data Inicial',
    },
    resultadosLoterias: {
      dataInicial: 'Data Inicial',
    },
  },
  pendingInstallations: {
    pdv: 'PDV',
  },
  crm: {
    title: 'CRM',
  },
  descargaOnline: {
    title: 'Módulo de Descarga',
  },
  cadastros: {
    credenciador: {
      tituloCadastro: 'Cadastro de {name}',
      tituloComissao: 'Cadastro de comissão {nameUp}: {name}',
      novoCadastro: 'Novo cadastro',
      editar: 'Editar',
      excluir: 'Excluir',
    },
    cuponsBonus: {
      visualizar: 'Visualizar',
    },
    estabelecimento: {
      pdv: 'PDV',
      dataCadastro: 'Data Cadastro',
      dataNascimento: 'Data de Nascimento',
      dadosPdv: 'Dados do PDV',
      editarLimitePdv: 'Editar limite do PDV',
    },
    metas: {
      dataReferencia: 'Data Referência',
    },
    preCaixa: {
      dataInicial: 'Data Inicial',
      dataFinal: 'Data Final',
      pdv: 'PDV',
    },
    terminais: {
      pdv: 'PDV',
      msgRodapeTerminal: {
        title: 'Cadastrar mensagem de rodapé dos terminais',
      },
    },
    pendentes: {
      pdv: 'PDV',
      dataCadastro: 'Data Cadastro',
      dataNascimento: 'Data de Nascimento',
    },
    usuariosWeb: {
      title: 'Usuários web',
      modalMotivoExclusao: {
        title: 'Motivo da exclusão do usuário',
      },
    },
    geolocalizacao: {
      pdv: 'PDV',
    },
    jogos: {
      title: 'Cancelamentos',
      tabs: {
        jogosWeb: 'Jogos Web',
        bilhetes: 'Bilhetes',
      },
      usuarioWeb: 'Usuário Web',
      terminal: 'Terminal',
      produtos: 'Produtos',
      nrBilhete: 'Nr. Bilhete',
      codigoJogo: 'Código do Jogo',
      codigoBilhete: 'Código do Bilhete',
    },
  },
  consultas: {
    ganhadores: {
      pdv: 'PDV',
      codigoBilhete: 'Código do Bilhete',
    },
    ganhadoresPlataforma: {
      pdv: 'PDV',
      codigoBilhete: 'Código do Bilhete',
    },
    instalacoes: {
      filterFields: {
        Entities: {
          cod: 'Código da entidade',
        },
        Devices: {
          serial: 'Devices -> Serial',
        },
      },
    },
    organizze: {
      filterFields: {
        entity_id: 'ID da Entidade',
        name: 'Nome',
        type: 'Tipo',
        value: 'Valor',
      },
    },
    premios: {
      codigoBilhete: 'Código do Bilhete',
    },
    senhaPreCaixa: {
      title: 'Senha para emissão de caixa',
    },
  },
  esportes: {
    bilhetes: {
      title: 'Bilhetes',
    },
  },
  financeiros: {
    despacho: {
      pdv: 'PDV',
    },
    lancamentoFinanceiro: {
      pdv: 'PDV',
      terminal: 'Terminal',
    },
    zeraSaldo: {
      pdv: 'PDV',
    },
  },
  jogadores: {
    title: 'Jogadores',
    modalMotivoExclusao: {
      title: 'Motivo da exclusão do usuário',
    },
  },
  components: {
    autoCompleteEntities: {
      terminal: 'Terminal',
      pdv: 'PDV',
    },
    dateModal: {
      data: 'Data',
    },
    rangeDate: {
      dataInicial: 'Data Inicial',
      dataFinal: 'Data Final',
    },
    rangeDateParceiros: {
      dataInicial: 'Data Inicial',
      dataFinal: 'Data Final',
    },
    tabelaHistoricoVendas: {
      relatorioLancamentoCaixaDebitos: 'Relatório Lançamento de Caixa (Débitos)',
    },
  },
  fieldLabels: {
    name: 'Nome',
    date: 'Data',
    cod: 'Código',
    address: 'Endereço',
    city: 'cidade',
    complement: 'Complemento',
    neighborhood: 'Bairro',
    number: 'Número',
    phone: 'Telefone',
    state: 'Estado',
    responsible: {
      name: 'Responsavel -> Nome',
      cpf: 'Responsavel -> CPF',
      address: 'Responsavel -> Endereço',
      businessPhone: 'Responsavel -> Número Comercial',
      cep: 'Responsavel -> CEP',
      number: 'Responsavel -> Número',
      city: 'Responsavel -> Cidade',
      complement: 'Responsavel -> Complemento',
      neighborhood: 'Responsavel -> Bairro',
      phone: 'Responsavel -> Celular',
      state: 'Responsavel -> Estado',
      phoneComercial: 'Responsavel -> Telefone',
    },
    value: 'valor',
    entity: 'Entidade',
    dtStart: 'Data Inicial',
    dtEnd: 'Data Final',
    dtDraw: 'Data Sorteio',
    description: 'Descrição',
    entityName: 'Nome do Usuário',
    entryTypeId: 'Tipo de Entidade ID',
    transaction: 'Transação',
    entityId: 'Entidade ID',
    id: 'ID',
    image: 'Imagem',
    ascertainedMethodId: 'Modalidade',
    Entities: {
      name: 'Nome da Entidade',
      cod: 'Código da entidade',
      birth: 'Data Aniversário da Entidade',
      cpf: 'CPF do Usuário',
      banco: 'Banco do Usuário',
      agencia: 'Agêncie do Usuário',
      conta: 'Conta do Usuário',
      digit: 'Dígito da Conta do Usuário',
      tipoConta: 'Tipo da Conta do Usuário',
    },
    Chips: {
      phoneNumber: 'Chips -> Número do Celular',
      iccid: 'Devices -> ICCID',
    },
    Devices: {
      serial: 'Devices -> Serial',
      deviceVersion: 'Devices -> Versão',
      hwSerial: 'Devices -> Código',
    },
    hwSerial: 'Código',
    iccid: 'ICCID',
    phoneNumber: 'Número do Chip',
    imsi: 'IMSI',
    deviceVersion: 'Versão do Device',
    serial: 'Serial',
    deviceTypeId: 'ID do Tipo de Device',
    status: 'Status',
    email: 'Email',
    deleted: 'Excluído',
    created: 'Data de Registro',
    influencer: 'Influenciador',
    Entity: {
      name: 'Nome da Entidade',
    },
    entryType: {
      description: 'Descrição do tipo de Entrada',
    },
    pendingOperationTypeId: 'ID Tipo Operação Pendendte',
    pendingOperation: {
      created: 'Data do registro',
    },
    pendingOperationType: {
      name: 'Nome Tipo Operação Pendendte',
    },
    'Sweepstakes:dtStart': 'Data inicial',
    'Sweepstakes:dtEnd': 'Data final',
    'Sweepstakes:dtDraw': 'Data sorteio',
    'Sweepstakes:id': 'ID',
    'Sweepstakes:cod': 'Código concurso',
    'WebPrizeRequests:id': 'ID',
    products: 'Produtos',
    'lg:gameNumber': 'Nº jogo',
    e: {
      jsonData: {
        name: 'Nome da Revenda',
      },
    },
    indexTypeRecurrence: 'Recorrência',
    'indexType:name': 'Tipo índice',
    Goals: {
      refDate: 'Data de Referência',
    },
    salesGoalValue: 'Meta de Vendas',
    debitGoalValue: 'Meta de Débito',
    resellersQuantityGoal: 'Qtd. Revendedores',
    EntityGoals: {
      status: 'Status da Meta(V, P)',
    },
    AffiliatesContractTypes: {
      contractTypeId: 'Tipo de contrato',
    },
    ComissionTypes: {
      comissionTypeId: 'Tipo de comissão',
    },
    ContractsAffiliateId: 'id',
    'ContractsAffiliate:name': 'nome',
  },
}
